import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {gaEventWithUserIdLabel, gaPageView, izNotBlank, LOG_OUT, uniqueArray} from "../constants";
import {UserAction} from "../actions/UserAction";
import {Button, Checkbox, DatePicker, Input, message, Modal, Select, Skeleton, Table, Tooltip} from "antd";
import ReportService from "../services/report.service";
import i18n from "i18next";
import AuthService from "../services/auth.service";
import {FileExcelOutlined, SearchOutlined} from "@ant-design/icons";
import moment from "moment";
import {SearchAction} from "../actions/SearchAction";
import $ from "jquery";
import CountUp from 'react-countup'
import localeTR from 'antd/es/date-picker/locale/tr_TR';
import localeEN from 'antd/es/date-picker/locale/en_GB';
import SearchCardModal from "./SearchCardModal";
import PdfDownloadLink from "./PdfDownloadLink";
import fileDownload from "js-file-download";

const {Option} = Select;
const {RangePicker} = DatePicker;

class Reports extends Component {

    constructor(props) {
        super(props)

        const searchId = ReportService.getSearchId();
        this.state = {
            mrBtnLoading: false,
            monthlyReportVisible: false,
            type: 'last_7_days',
            searchFilter: searchId,
            onlyFound: true,
            hideSearchResultComponent: true,
            searching: false,
            excelReportDate: moment().format("YYYY-MM"),
            startDate: '',
            endDate: '',
            apiFoundCount: 0, apiReqCount: 0, excelFoundCount: 0, excelReqCount: 0, uiFoundCount: 0, uiReqCount: 0,
            columns: [
                {
                    title: '',
                    key: 'itemId',
                    dataIndex: 'itemId',
                    render: (itemId, record) => this.itemComponent(record)
                },
            ],
            items: []
        }

        this.pullReportSummary();

        if (searchId) {
            setTimeout(function () {
                this.search();
            }.bind(this), 751);
        }
    }

    itemComponent(item) {
        // let includePeP = item.includePeP
        let itemId = item.itemId
        let searchId = item.searchId
        let searcher = item.searcher
        let searchDate = item.searchDate
        let searchParam = item.searchParam
        let searchType = item.searchType;
        let searchKey = this.searchKey(searchType, searchParam)
        let foundLists = uniqueArray(item.foundLists)

        let found = !!foundLists.length;

        const searching = this.state.searching;

        let searchTypeVal = i18n.t('searchType_' + searchType);

        let pepExist = !!foundLists.filter(s => s === "PEP").length;
        let foundSanctionListsSize = foundLists.filter(s => s !== "PEP").length;
        let foundSanctionLists = !!foundSanctionListsSize;

        return (
            <Skeleton loading={searching} active>
                <div className="row justify-content-between">
                    <div className="col-md-7 col-lg-8">
                        <ul>
                            <li><strong>{i18n.t('searchId')}</strong>{searchId}</li>
                            <li><strong>{i18n.t('searcher')}</strong>{searcher}</li>
                            <li><strong>{i18n.t('searchType')}</strong>{searchTypeVal}</li>
                            <li><strong>{i18n.t('searchParam')}</strong>{searchKey}</li>
                            <li><strong>{i18n.t('searchDate')}</strong>{searchDate}</li>
                        </ul>
                    </div>
                    <div className="col-md-5 col-lg-4 text-left text-md-right margin-auto">
                        <ul className="report-search-result-match-ul">
                            <li>
                                {found
                                    ?
                                    <div className="d-flex justify-content-start justify-content-md-end">
                                        {pepExist &&
                                            <div className="report-search-result-matched-PEP">PeP</div>
                                        }
                                        {foundSanctionLists &&
                                            <div className="report-search-result-matched">{i18n.t('foundIn', {foundListsSize: foundSanctionListsSize})}</div>
                                        }
                                    </div>
                                    :
                                    <>
                                        <label className="report-search-result-no-match">
                                            {i18n.t('notFound')}
                                        </label>
                                    </>
                                }
                            </li>
                            <li>
                                <PdfDownloadLink itemId={itemId} searchId={searchId}/>
                            </li>
                            <li>
                                {found &&
                                    <div>
                                        <SearchCardModal itemId={itemId} text={i18n.t('showDetails')}
                                                         searchType={searchType} searchId={searchId}/>
                                    </div>
                                }
                            </li>
                        </ul>
                    </div>
                </div>
            </Skeleton>
        )
    }

    searchKey(searchType, searchParam) {

        let searchKey = ""

        switch (searchType) {
            case "PERSON_NAME":
                searchKey += searchParam.personName;
                if (izNotBlank(searchParam.placeOfBirth)) searchKey += " - " + searchParam.placeOfBirth;
                if (izNotBlank(searchParam.yearOfBirth)) searchKey += " - " + searchParam.yearOfBirth;
                break;
            case "PERSON_ID":
                searchKey = searchParam.personIdentification;
                break;
            case "ENTITY_NAME":
                searchKey += searchParam.entityName;
                if (izNotBlank(searchParam.entityAddress)) searchKey += " - " + searchParam.entityAddress;
                break;
            case "ENTITY_ID":
                searchKey = searchParam.entityIdentification;
                break;
            case "COUNTRY_NAME":
                searchKey += searchParam.countryName;
                break;
        }

        return searchKey
    }

    pullReportSummary() {
        ReportService.summary()
            .then(
                response => {
                    if (response.data.success === true) {
                        const {apiFoundCount, apiReqCount, excelFoundCount, excelReqCount, uiFoundCount, uiReqCount} = response.data
                        this.setState(state => ({
                            ...state,
                            apiFoundCount, apiReqCount, excelFoundCount, excelReqCount, uiFoundCount, uiReqCount
                        }));
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ReportService.summary Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    search = () => {

        const {type, startDate, endDate, searchFilter, onlyFound} = this.state

        if (type === 'range') {
            if (!startDate || startDate.trim() === "" || !endDate || endDate.trim() === "") {
                return message.error(i18n.t('error_date_range'))
            }
        }

        this.setState({searching: true})

        ReportService.search(type, startDate, endDate, searchFilter, onlyFound)
            .then(
                response => {
                    if (response.data.success === true) {
                        const items = response.data.items

                        $('html, body').animate({
                            scrollTop: $("#report-search-wrapper-id").offset().top + $("#report-search-wrapper-id").height()
                        }, 1000)

                        this.setState({
                            searching: false,
                            items: items ? items : [],
                            hideSearchResultComponent: false
                        })
                    } else {
                        this.setState({
                            searching: false,
                            items: [],
                            hideSearchResultComponent: false
                        })

                        if (response.data.error && response.data.error !== "") {
                            message.error(response.data.error)
                        } else {
                            message.error(i18n.t('global_error'))
                        }
                    }
                },
                error => {
                    this.setState({
                        searching: false,
                        items: [],
                        hideSearchResultComponent: false
                    })

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ReportService.search Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    };

    excelMonthlyReport = () => {

        if (this.state.mrBtnLoading) return;

        this.setState({mrBtnLoading: true});

        const {excelReportDate} = this.state
        const finalDate = excelReportDate + "-01"

        ReportService.excelMonthlyReport(finalDate)
            .then(
                response => {
                    if (response.data) {
                        let blob = new Blob([response.data], {type: 'application/octet-stream'})
                        if (blob.size > 313) {
                            const fileName = "Search Sanctions AML Search Monthly Report " + excelReportDate + ".xlsx";
                            fileDownload(response.data, fileName)
                            this.setState({monthlyReportVisible: false});
                        } else {
                            message.error(i18n.t('excel_report_data_not_fount'))
                        }
                    } else {
                        gaEventWithUserIdLabel("ReportService.excelMonthlyReport Data nil Error")
                        message.error(i18n.t('global_error'))
                    }
                    this.setState({mrBtnLoading: false});
                },
                error => {
                    this.setState({mrBtnLoading: false});

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ReportService.excelMonthlyReport Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    };

    componentDidMount() {
        gaPageView()
    }

    handleDateType = type => {
        this.setState({
            type: type
        })
    }

    handleRanges = dates => {

        let startDate = dates[0] ? moment(dates[0]).format("YYYY-MM-DD") : '';
        let endDate = dates[1] ? moment(dates[1]).format("YYYY-MM-DD") : '';
        this.setState({
            startDate: startDate,
            endDate: endDate
        })
    }

    handleInputChange = (e) => {
        let {name, value} = e.target
        this.setState({
            [name]: value
        })
    }

    handleChecked = (e) => {
        this.setState({
            onlyFound: e.target.checked
        })
    }

    getAntdLocale() {
        let lang = this.props.common.lang
        if (lang && lang === "tr") {
            let trLocale = require('moment/locale/tr');
            moment.updateLocale('tr', trLocale)
            return localeTR;
        } else {
            let enLocale = require('moment/locale/en-gb');
            moment.updateLocale('en', enLocale)
            return localeEN;
        }
    }

    getDuration(count) {
        return 50 < count ? 1.993 : .366;
    }

    showModal = () => {
        this.setState({
            monthlyReportVisible: true,
        });
    };

    handleCancel = () => {
        this.setState({
            monthlyReportVisible: false,
        });
    };

    onMonthChange = (date, dateString) => {
        this.setState({excelReportDate: dateString})
    };

    render() {

        const {type, searchFilter, onlyFound, hideSearchResultComponent, searching, mrBtnLoading} = this.state
        const {apiFoundCount, apiReqCount, excelFoundCount, excelReqCount, uiFoundCount, uiReqCount} = this.state
        const {columns, items} = this.state

        const totalReqCount = uiReqCount + apiReqCount + excelReqCount;
        const totalFoundCount = uiFoundCount + apiFoundCount + excelFoundCount;

        const showMonthlyReport = AuthService.hasRole("MONTHLY_REPORT");

        return (
            <>
                <section className="ms-section pb-20">

                    <div className="container">
                        <div className="row justify-content-center pb-25">
                            <div className="form-box-report report-summary custom-box-shadow">
                                <h4 className="pb-35">{i18n.t('searchSummary')}</h4>

                                <div className="row justify-content-around">
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 pb-5">
                                        <ul>
                                            <li><label className="underlined-label">{i18n.t('console')}</label></li>
                                            <li>{i18n.t('reqCount')}</li>
                                            <li><strong><CountUp end={uiReqCount} duration={this.getDuration(uiReqCount)}/></strong></li>
                                            <li>{i18n.t('foundCount')}</li>
                                            <li><strong><CountUp end={uiFoundCount} duration={this.getDuration(uiFoundCount)}/></strong></li>
                                        </ul>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 pb-5">
                                        <ul>
                                            <li><label className="underlined-label">{i18n.t('enterpriseAPI')}</label></li>
                                            <li>{i18n.t('reqCount')}</li>
                                            <li><strong><CountUp end={apiReqCount} duration={this.getDuration(apiReqCount)}/></strong></li>
                                            <li>{i18n.t('foundCount')}</li>
                                            <li><strong><CountUp end={apiFoundCount} duration={this.getDuration(apiFoundCount)}/></strong></li>
                                        </ul>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 pb-5">
                                        <ul>
                                            <li><label className="underlined-label">{i18n.t('excelArama')}</label></li>
                                            <li>{i18n.t('reqCount')}</li>
                                            <li><strong><CountUp end={excelReqCount} duration={this.getDuration(excelReqCount)}/></strong></li>
                                            <li>{i18n.t('foundCount')}</li>
                                            <li><strong><CountUp end={excelFoundCount} duration={this.getDuration(excelFoundCount)}/></strong></li>
                                        </ul>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 pb-5">
                                        <ul>
                                            <li><label className="underlined-label">{i18n.t('total')}</label></li>
                                            <li>{i18n.t('reqCount')}</li>
                                            <li><strong><CountUp end={totalReqCount} duration={this.getDuration(totalReqCount)}/></strong></li>
                                            <li>{i18n.t('foundCount')}</li>
                                            <li><strong><CountUp end={totalFoundCount} duration={this.getDuration(totalFoundCount)}/></strong></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row justify-content-center pb-25" id="report-search-wrapper-id">
                            <div className="form-box-report report-detail-search custom-box-shadow">

                                {
                                    showMonthlyReport &&
                                    <Tooltip
                                        placement="left"
                                        title={i18n.t("get_excel_report")}
                                        color={"204f79"}
                                        key={"coloredTT1"}
                                    >
                                        <Button size='large' className='monthly-report-button' type="default" onClick={this.showModal}>
                                            <FileExcelOutlined/>
                                        </Button>
                                    </Tooltip>
                                }

                                <h4 className="pb-35">{i18n.t('detailSearch')}</h4>

                                <div className="row pb-25">
                                    <div className="col-12">

                                        <Select
                                            className="custom-report-range"
                                            value={type}
                                            size="large"
                                            onChange={type => this.handleDateType(type)}
                                        >
                                            <Option key="last_7_days" value="last_7_days">{i18n.t('last_7_days')}</Option>
                                            <Option key="last_15_days" value="last_15_days">{i18n.t('last_15_days')}</Option>
                                            <Option key="last_1_month" value="last_1_month">{i18n.t('last_1_month')}</Option>
                                            <Option key="last_3_month" value="last_3_month">{i18n.t('last_3_month')}</Option>
                                            <Option key="range" value="range">{i18n.t('range')}</Option>
                                        </Select>

                                        {type === 'range' &&
                                            <RangePicker
                                                locale={this.getAntdLocale()}
                                                size="large"
                                                onChange={this.handleRanges}
                                            />
                                        }

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-7 pb-25">
                                        <Input
                                            placeholder={i18n.t('searchFilter')}
                                            prefix={<SearchOutlined/>}
                                            name="searchFilter"
                                            size="large"
                                            onChange={this.handleInputChange}
                                            value={searchFilter}
                                        />
                                    </div>
                                    <div className="col-12 col-md-5 pb-25 checking-area">
                                        <label className="pr-15" htmlFor="onlyFound">{i18n.t('onlyFound')}</label>

                                        <Checkbox
                                            id="onlyFound"
                                            name="onlyFound"
                                            size="large"
                                            checked={onlyFound}
                                            onChange={this.handleChecked}
                                        >
                                        </Checkbox>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <Button
                                            className="custom-button"
                                            type="primary"
                                            onClick={this.search}
                                            loading={searching}
                                            style={{marginTop: 1}}
                                        >
                                            {searching ? i18n.t('searching') : i18n.t('detailSearching')}
                                        </Button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {hideSearchResultComponent !== true &&
                            <div className="row justify-content-center pb-25">
                                <div className="form-box-report report-search-result custom-box-shadow">

                                    {!!items.length ?
                                        <>
                                            <div className="report-search-result-count"><strong>{items.length}</strong> {i18n.t('recordsFound')}</div>
                                            <Table
                                                showHeader={false}
                                                columns={columns}
                                                dataSource={items}/>
                                        </>
                                        :
                                        <div className="report-search-result-count">{i18n.t('recordsNotFound')}</div>
                                    }

                                </div>
                            </div>
                        }

                    </div>
                </section>

                <Modal
                    className='monthly-excel-modal'
                    title={i18n.t("excel_report_modal_title")}
                    visible={this.state.monthlyReportVisible}
                    okText={i18n.t("download")}
                    onOk={this.excelMonthlyReport}
                    confirmLoading={mrBtnLoading}
                    cancelText={i18n.t("cancel")}
                    onCancel={this.handleCancel}
                >
                    <p style={{textAlign: 'center', margin: 'auto'}}>{i18n.t("please_select_date")}</p>
                    <div className='monthly-report-date-pickers'>
                        <DatePicker.MonthPicker size="large"
                                                allowClear={false}
                                                disabledDate={(current) => {
                                                    let minDate = moment("2020-01-01");
                                                    let maxDate = moment().format("YYYY-MM-DD");

                                                    let ltMin = current && current < moment(minDate, "YYYY-MM-DD");
                                                    let gtMax = current && moment(maxDate, "YYYY-MM-DD") < current;

                                                    return ltMin || gtMax;
                                                }}
                                                placement={"bottomLeft"}
                                                defaultValue={moment().startOf("month")}
                                                placeholder={i18n.t('select_date_placeholder')}
                                                onChange={this.onMonthChange}
                                                locale={this.getAntdLocale()}/>
                    </div>

                </Modal>

            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports);